export const parseDate = dateString => {
  const date = dateString.includes('T') ? dateString.split('T')[0] : dateString

  return date
}

export const formatDate = (
  date,
  options = { year: 'numeric', month: 'numeric', day: 'numeric' },
) => {
  const newDate = new Date(date).toLocaleDateString(undefined, options)

  return newDate.replaceAll('/', '-')
}
